type BookingAmountsSource = {
    price?: number;
    totalPaid?: number;
    totalBill?: number;
};

type BookingScheduleBookingRow = BookingAmountsSource & {
    booking?: BookingAmountsSource;
};

export type BookingScheduleBookingAmounts = {
    paid: number;
    total: number;
    pending: number;
};

// Importes de una reserva de la reserva fija:
// - paid: lo cobrado (0 hasta que se cobra)
// - total: el importe de la reserva
// - pending: la deuda generada aún sin cobrar
export function getBookingScheduleBookingAmounts(
    row: BookingScheduleBookingRow,
): BookingScheduleBookingAmounts {
    const paid = row.booking?.totalPaid ?? row.totalPaid ?? 0;
    const total = row.booking?.price ?? row.price ?? 0;
    const bill = row.booking?.totalBill ?? row.totalBill ?? 0;

    return { paid, total, pending: bill - paid };
}
